import { APP_NAMES } from './const/app-names.const'
import { ENVIRONMENT_PREFIX } from './const/environment-prefix.const'
import { detectEnvironment } from './utils/detect-environment.util'

function getFallbackPortalUrl(): string {
  const environment = detectEnvironment()
  const envPrefix = ENVIRONMENT_PREFIX[environment]
  return envPrefix
    ? `https://${APP_NAMES.portal}.${envPrefix}.graftcode.com`
    : `https://${APP_NAMES.portal}.graftcode.com`
}

/** Server-safe portal origin (no client navigation module). */
export function getPortalBaseUrl(): string {
  if (process.env.NEXT_PUBLIC_VISION_MODE === 'local') {
    return getFallbackPortalUrl()
  }

  const envValue = process.env.NEXT_PUBLIC_WEB_PORTAL_URL?.trim()
  if (envValue && !envValue.startsWith('BAKED_')) {
    return envValue.replace(/\/$/, '')
  }

  return getFallbackPortalUrl()
}
